export const formControlErrorMapper = [
    {
        formControlName: 'summary',
        humanizedError: '* Summary is required.'
    },
    {
        formControlName: 'description',
        humanizedError: '* Circumstances is required.'
    },
    {
        formControlName: 'fundPledgeTypeId',
        humanizedError: '* Fund type is required.'
    },
    {
        formControlName: 'totalNeed',
        humanizedError: '* Total amount needed is required.'
    },
    {
        formControlName: 'companies',
        humanizedError: '* One or more companies (or payees) has an invalid value.'
    },
    {
        formControlName: 'adults',
        humanizedError: '* One or more adults has an invalid value.'
    },
    {
        formControlName: 'minors',
        humanizedError: '* One or more minors has an invalid value.'
    },
    {
        formControlName: 'assistanceApplicationAreasOfNeed',
        humanizedError: '* You must check at least one type of assistance.'
    },
    {
        formControlName: 'files',
        humanizedError: '* Missing file(s). Expand "What documents do I need" for more information.'
    },
    {
        formControlName: 'otherDenialReason',
        humanizedError: '* Denial reason explanation is required.'
    },
    {
        formControlName: 'tierLevel',
        humanizedError: '* Tier level is required.'
    },
    {
        formControlName: 'visionLinkNumber',
        humanizedError: '* Vision Link number is required.'
    }
];

export const fileErrorNames = [
    'photoIdRequired',
    'utilityOrEquivalentRequired',
    'incomeDocumentRequiredForSelfEmployed',
    'incomeDocumentRequiredForNonSelfEmployed',
    'childcareBillRequired',
    'autoRepairBillRequired',
    'utilityBillOrShutoffNoticeRequired',
    'evictionCourtOrderRequired',
    'leaseAgreementRequired',
    'delinquentRentNoticeRequired',

    'residenceProofRequired',
    'landlordOwnershipRequired',
    'rentLandlordFormRequired',
    'evictionCourtRecordRequired',
    'mortgageStatementRequired',
    'movingExpenseBillRequired',
    'autoInsuranceBillRequired',
    'autoPaymentStatementRequired',
    'autoTitleRequired',
    'tuitionBillRequired',
    'childEducationBillRequired',
    'childEnrollmentProofRequired',
    'childProgressReportRequired',
    'tutoringInvoiceRequired',
    'delinquentWaterBillRequired',
    'proofOfCovidHardshipRequired',
    'ssnProofRequired',
    'stormAppliancesInvoiceOrEstimateRequired',
    'stormConstructionInvoiceOrEstimateRequired',
    'stormHvacPlumbingInvoiceOrEstimateRequired',
    'stormMoldRemediationInvoiceRequired',
    'stormOtherUnmetNeedsInvoiceOrEstimateRequired',
    'stormStorageStatementOrEstimateRequired',
];
